import { Button } from 'blaze-ui/Button'
import { AlertTriangle } from 'blaze-ui/icons/20/AlertTriangle'
import cx from 'classnames'
import Styles from './ValidationBanner.module.scss'
import { getCharacterLimitViolations, getPlatformDisplayName, type PlatformLimits } from './utils'

interface ValidationBannerProps {
  content: string
  selectedPlatform?: PlatformLimits
  className?: string
  hideIcon?: boolean
  action?: {
    label: string
    onClick: () => void
  }
}

export const ValidationBanner = ({
  content,
  selectedPlatform,
  className,
  hideIcon = false,
  action,
}: ValidationBannerProps) => {
  const violations = selectedPlatform ? getCharacterLimitViolations(content, [selectedPlatform]) : []

  if (violations.length === 0) {
    return null
  }

  const getMessage = () => {
    const violation = violations[0]
    const platformDisplayName = getPlatformDisplayName(violation.platform)
    return `Your post exceeded the character limit for ${platformDisplayName}`
  }

  return (
    <div className={cx(Styles.banner, className)} data-testid="validation-banner">
      {!hideIcon && (
        <div className={Styles.iconSection} data-testid="validation-icon">
          <AlertTriangle size={20} color="var(--negative-60)" />
        </div>
      )}
      <div className={Styles.content}>
        <span className={Styles.message}>{getMessage()}</span>
      </div>
      {action && (
        <Button
          variant="tertiary"
          size="sm"
          onPress={action.onClick}
          className={Styles.actionButton}
          data-testid="validation-action-button"
        >
          {action.label}
        </Button>
      )}
    </div>
  )
}
